import React, { createContext, useContext, useState } from 'react';

const LikedProductsContext = createContext();

export const LikedProductsProvider = ({ children }) => {
  const [likedProducts, setLikedProducts] = useState([]);

  const toggleLike = async (productId, api, username) => {
    try {
      await api.post(`/products/${productId}/like`, { username });

      setLikedProducts(prev =>
        prev.includes(productId)
          ? prev.filter(id => id !== productId)
          : [...prev, productId]
      );
    } catch (err) {
      console.error('❌ Failed to toggle like:', err);
    }
  };

  return (
    <LikedProductsContext.Provider
      value={{
        likedProducts,
        toggleLike,
        setLikedProducts, // ✅ expose it so ProductDetailScreen & MarketContext can hydrate likes
      }}
    >
      {children}
    </LikedProductsContext.Provider>
  );
};

export const useLikedProducts = () => useContext(LikedProductsContext);
